<template>
  <!-- 弹窗 -->

  <div id="subscribePopup" v-if="!popup == 0">
    <div class="mask" @click="close(isMask)"></div>
    <div :class="popup === 3 || popup === 4 || popup === 5
      ? 'popup gamegift'
      : 'popup'" :style="bg ? `backgroundColor:${bg}` : ''">
      <!-- 头部渐变 -->
      <div class="linear">
        <div class="linear_lt">
        </div>
        <div class="code_title">云游戏</div>
        <div class="linear_rt">
        </div>
      </div>
      <!-- 标题 -->
      <div v-if="title" class="top" :style="color ? `backgroundColor:${color}`
        : bg ? 'borderBottom:none' : ''">
        <p class="top_p" :style="color ? 'color:#fff' : ''">{{ title }}</p>
        <img v-if="!color && closeIcon == 0" @click="close(true)" src="@/assets/image/reserve_cancel_ic.png" alt="">
      </div>

      <!-- 内容 -->
      <div class="constent" v-if="content">
        <p class="content_p1" v-html="content"></p>
        <p class="content_p2" v-if="content2">{{ content2 }}</p>
      </div>
      <div class="constent" v-if="!content && popup != 5 && popup != 6">
        <slot name="constent"></slot>
      </div>
      <!-- 按钮 -->
      <div v-if="popup == 1 || popup == 3" :class="popup === 3 ? 'bottom gameBotttom' : 'bottom'">
        <button @click="close(true)" class="close">取消</button>
        <button @click="determine" class="determine">确定</button>
      </div>
      <div v-if="popup === 2" class="bottom">
        <slot name="button"></slot>
      </div>
      <div v-if="popup === 4" class="bottom gameBotttom">
        <slot name="button"></slot>
      </div>

      <!--  -->
      <div v-if="popup == 5">
        <slot name="constent"></slot>
      </div>
      <div v-if="popup == 6">
        <slot name="constent"></slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "subscribePopup",
  props: {
    popup: Number,// 0-取消弹窗 1-弹窗在下方 2-弹窗在下方且按钮使用slot 3-弹窗居中 4-弹窗居中且按钮使用slot 5-弹窗居中 6-弹窗在下方
    title: String,// 标题
    content: String,// 内容1
    content2: String,// 内容2
    color: String,// 弹窗标题颜色
    bg: String,//弹窗背景颜色
    closeIcon: { //是否显示取消图标
      type: Number,
      default: 0 // 默认值为0
    },
    isMask: {
      type: Boolean,
      default: false // 默认值为0
    }
  },
  data() {
    return {

    }
  },

  methods: {
    // 取消
    close(type) {
      if (type) {
        this.$emit('close');
      }
    },
    // 预约确定
    determine() {
      this.$emit('determine');
    },
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>